import { Logo } from "@/components/common/Logo";
import { ThemeToggle } from "@/components/common/ThemeToggle";

/**
 * The frame of every full page outside the call (errors, the preview, the
 * leave page), after Cal.com's booking pages: the logo on a gray page, the
 * content centred, the version and the theme switch at the bottom. Help
 * lives in each page's card, where it applies.
 */
export const PageShell = ({ children }) => (
  <div className="flex min-h-full flex-col bg-background">
    <header
      className="flex h-14 shrink-0 items-center px-4 sm:px-6"
      data-testid="header"
    >
      <Logo />
    </header>
    <main className="flex flex-1 flex-col items-center justify-center px-4 py-6">
      {children}
    </main>
    <footer className="flex shrink-0 flex-wrap items-center justify-between gap-3 px-4 pb-4 text-xs text-muted-foreground sm:px-6">
      <span className="tabular-nums">
        {process.env.REACT_APP_VERSION
          ? `v${process.env.REACT_APP_VERSION}`
          : null}
      </span>
      <ThemeToggle />
    </footer>
  </div>
);
